<template>
  <v-container>
    <!-- Form Name -->
    <v-toolbar color="blue-grey darken-2">
      <v-toolbar-title class="white--text">New Dataset</v-toolbar-title>
    </v-toolbar>
    <v-card color="grey lighten-3">
      <v-card-text>
        <v-layout 
          justify-center 
          row 
          wrap
        >
          <v-flex 
            xs10 
            lg8 
            xl6
          >
            <v-form>
              <!-- Dataset ID -->
              <v-text-field 
                v-model="newDataset.dataset_id"
                :error-messages="textFieldErrors($v.newDataset.dataset_id)"
                label="Dataset ID" 
                :hint="`${newDataset.dataset_id.length}/40 Characters - ABBR ex. SCSS`"
                required
                clearable
                @input="$v.newDataset.dataset_id.$touch()"
                @blur="$v.newDataset.dataset_id.$touch()"
                data-cy="new-dataset-id">
              </v-text-field>

              <!-- Dataset Name -->
              <v-text-field 
                v-model="newDataset.dataset_name"
                label="Dataset Name" 
                :hint="`${newDataset.dataset_name.length}/200 Characters - ABBR ex. Campus Sensor Capture Project`"
                :error-messages="textFieldErrors($v.newDataset.dataset_name)"
                clearable
                required
                @input="$v.newDataset.dataset_name.$touch()"
                @blur="$v.newDataset.dataset_name.$touch()"
                data-cy="new-dataset-name">
              </v-text-field>

              <!-- Dataset DataFormats -->
              <v-select
                v-model="selectedDataFormat"
                :error-messages="dropDownFieldErrors($v.selectedDataFormat)"
                :items="dataFormats"
                label="Dataset Data Format"
                item-text="data_format_desc"
                item-value="data_format_cd"
                required
                @input="$v.selectedDataFormat.$touch()"
                @blur="$v.selectedDataFormat.$touch()"
                data-cy="new-dataset-dataformat"
                ref="new-dataset-dataformat">
              </v-select>

              <!-- Dataset Classifications -->
              <v-select
                v-model="selectedClassification"
                :error-messages="dropDownFieldErrors($v.selectedClassification)"
                :items="classifications"
                label="Dataset Classification"
                item-text="classification_desc"
                item-value="classification_cd"
                required
                @input="$v.selectedClassification.$touch()"
                @blur="$v.selectedClassification.$touch()"
                data-cy="new-dataset-classification"
                ref="new-dataset-classification">
              </v-select>

              <!-- Dataset Description-->           
              <v-textarea
                v-model="newDataset.dataset_desc"
                label="Dataset Description"
                :hint="`${newDataset.dataset_desc.length}/700 Characters - Description of Dataset`"
                :error-messages="textFieldErrors($v.newDataset.dataset_desc)"
                required
                @input="$v.newDataset.dataset_desc.$touch()"
                @blur="$v.newDataset.dataset_desc.$touch()"
                data-cy="new-dataset-dataformat-desc">
              </v-textarea>

            </v-form>            
          </v-flex>       
          <v-flex xs12>
            <v-btn 
              flat
              color="primary"
              @click="submit"
              :disabled="$v.newDataset.$invalid"
              data-cy="new-dataset-submit"
            >
              Submit
            </v-btn>
            <v-btn
              flat
              color="error"
              @click="clearForm"
              data-cy="new-dataset-reset"
            >
              Reset
            </v-btn>
          </v-flex>
        </v-layout>

      </v-card-text>
    </v-card>
  </v-container>
</template>


<script>
import { mapMutations, mapGetters, mapActions, mapState } from 'vuex'
import { required, numeric, helpers, maxLength } from 'vuelidate/lib/validators'
import { validationMixin } from '../validators.js'

export default {
  mixins: [validationMixin],
  data () {
    return {
      startDate: null,
      endDate: null,
      showEndDate: false,
      showStartDate: false,
      newDataset: {
        dataset_id: '',
        dataset_name: '',
        dataset_desc: '',
      },
      selectedDataFormat: '',
      selectedClassification: ''
    }
  },
  validations: {
    newDataset: {
      dataset_id: {
        required,
        maxLength: maxLength(40)
      },
      dataset_name: {
        required,
        maxLength: maxLength(200)
      },
      dataset_desc: {
        required,
        maxLength: maxLength(700)
      },

    },
    selectedDataFormat: {
      required
    },
    selectedClassification: {
      required
    }
  },
  computed: {
    ...mapState({
      dataFormats: state => state.dataset.transactions.allDataFormats,
      classifications: state => state.dataset.transactions.allClassifications
    })
  },
  methods: {
    ...mapActions([
      'createDatasetAction',
      'addDatasetDataFormatCreate',
      'addDatasetClassificationCreate',
      'fetchAllClassificationsAction',
      'fetchAllDataFormatsAction'
    ]),
    ...mapMutations([
      'logError'
    ]),
    clearForm () {
      this.newDataset.dataset_id = ''
      this.newDataset.dataset_name = ''
      this.newDataset.dataset_desc = ''
      this.selectedDataFormat = ''
      this.selectedClassification = ''
      this.$v.$reset()
    },
    createNewDataset () {
      const payload = {
        data: { ...this.newDataset }
      }
      this.createDatasetAction(payload)
        .then((response) => {
          const data = {
            json: {
              data_format_cd: this.selectedDataFormat
            },
            datasetKey: response.data.dataset.dataset_key
          }

          const classificationData = {
            json: {
              classification_cd: this.selectedClassification
            },
            datasetKey: response.data.dataset.dataset_key
          }

          //Todo: why does this fail here on success?
          Promise.all([this.addDatasetClassificationCreate(classificationData), this.addDatasetDataFormatCreate(data)])
           .then(() => this.$router.push(`/dataset/${data.datasetKey}`))
           .catch(e => this.$store.commit('logError', e))
        })
    },
    submit () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.createNewDataset()
      }
    }
  },
  mounted () {
    this.fetchAllDataFormatsAction()
    this.fetchAllClassificationsAction()
  }
}
</script>